import { CustomError, HttpStatus, ICustomError } from "./CustomError";
import { CustomEvent, ICustomEvent } from "./CustomEvent";
import { ISessionInfo, SessionInfo } from "./SessionInfo";


export interface IApplicationState {

    error: ICustomError;
    onErrorChange: ICustomEvent<ICustomError>;
    setError(newError: ICustomError): void;
    resetError(): void;

    sessionInfo: ISessionInfo;
}

export class ApplicationState implements IApplicationState {

    private static _applicationState: ApplicationState;

    public readonly onErrorChange: ICustomEvent<ICustomError> = new CustomEvent<CustomError>();
    protected _error: ICustomError;
    public get error(): ICustomError { return this._error; };

    protected _sessionInfo: ISessionInfo;
    public get sessionInfo(): ISessionInfo { return this._sessionInfo; };

    constructor() {
        //console.log("Creating ApplicationState instance: " + MyDateTime.now.second.toString() + " " + ApplicationState._applicationState);
        // In development/HMR scenarios, just reuse existing instance
        if (ApplicationState._applicationState) {
            return ApplicationState._applicationState;
        }
    
        // if (ApplicationState._applicationState) {
        //     throw new CustomError("Cannot create instance of ApplicationState. use ApplicationState.get() instead", HttpStatus.httpUnknown, null, null, null, null);
        // }
        ApplicationState._applicationState = this;

        this._error = null;
        this._sessionInfo = new SessionInfo();
    }

    public static createOnce(): void{
        if (!ApplicationState._applicationState) {
            new ApplicationState(); //Create the state object once.
        }
    }

    public static get(): ApplicationState{
        return ApplicationState._applicationState
    };


    // Error helpers
    public setError(newError: ICustomError | string): void {
        if(typeof newError === 'string'){
            const err = new CustomError(newError,HttpStatus.httpUnknown, '','',0,'');
            this._error = err;
        }
        else{
            this._error = newError;
        }
        this.onErrorChange.trigger(this._error);
    }

    public resetError(): void {
        this.setError(null);
    }

}

